export enum ScrollTypes {
    WorkspaceViewComponent = 'WorkspaceViewComponent',
    CohortDetailComponent = 'CohortDetailComponent'
}
